// extracted by mini-css-extract-plugin
export default {"complex":"styles_complex__-xrFB","scrollable":"styles_scrollable__EnElD"};